import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import { i18n } from './plugins/i18n'
import UIcon from './plugins/unistra/UIcon'
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';

Vue.config.productionTip = false

Vue.component('u-icon', UIcon)

if (process.env.VUE_APP_DEPLOYMENT_ENV !== 'dev') {
  Sentry.init({
    dsn: 'https://944c477890804fadb965712fe7047509@sentry.app.unistra.fr/26',
    release: VERSION, // eslint-disable-line no-undef
    environment: process.env.VUE_APP_DEPLOYMENT_ENV,
    integrations: [
      new Integrations.Vue({
        Vue,
        attachProps: true,
      }),
    ],
  });
}


new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App),
}).$mount('#app')
